import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/pkd_logo.jpeg'; 

const Header = () => {
  return (
    <header className="container">
      <div className="header">
        <div className="logo-container">
          {/* Logo Image */}
          <Link to="/">
             <img src={logoImage} alt="ISPKD Logo" className="logo-img" />
          </Link>
        </div>
        <div className="header-actions">
          <a href="/#contact" className="btn btn-primary">Contact us</a>
          <Link to="/apply_new_membership" className="btn btn-primary">Apply Membership</Link>
        </div>
      </div>
    </header>
  );
};

export default Header;